module.exports = __webpack_public_path__ + "static/media/ShipstonForms.196c63e9.png";